import Tooltip from "@components/Tooltip";
import EmptyWarning from "assets/svg/empty-warning.svg";
import Search from "assets/svg/search.svg";
import gate from "gate";
import debounce from "lodash/debounce";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC, useEffect, useRef, useState } from "react";
import { useInfiniteQuery } from "react-query";
import { useDispatch } from "react-redux";

import { Spinner, Vlist } from "..";

const SearchBar: FC<any> = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();

  const [variables, setVariables] = useState({ query: "" });
  const {
    fetchNextPage,
    isLoading,
    isFetching,
    data,
    refetch,
    hasNextPage,
  }: any = useInfiniteQuery(
    [`products`],
    (page) => variables.query.length !== 0 && gate.search({ ...variables }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      select: (data: any) => data,
    }
  );

  useEffect(() => {
    refetch(variables);
  }, [variables]);

  const delayedQuery = useRef(
    debounce(
      ({ text }) =>
        setVariables((prev: any) => ({
          ...prev,
          query: text,
        })),
      500
    )
  ).current;
  const pagesData =
    data?.pages
      ?.map((a: any) => a?.data?.output)
      .reduce((a: any, b: any) => [...a, ...b]) ?? [];

  const handleClickSearch = (
    e: React.KeyboardEvent<HTMLInputElement> | any
  ) => {
    e.preventDefault();
    if (e.key === "Enter") {
      router.push(
        {
          pathname: `/search`,
          query: { query: e?.target?.value },
        },
        undefined,
        { shallow: true }
      );
    }
  };

  return (
    <>
      <div className="flex h-auto w-full items-center py-4 px-[10%] md:py-5 xl:h-36">
        <Tooltip
          text={
            "جهت جستجوی دقیق‌تر، <span class='font-bold'>\"جستجوی پیشرفته\"</span> را کلیک نمایید."
          }
          arrowPlacement={"bottom-left"}
          customClass="!text-[16px]"
          parentCustomClass="w-full md:w-auto"
          bgColor="bg-bottom-warning"
        >
          <div className="flex h-[45px] items-center justify-center rounded-lg border-y-2 border-r-2 border-blue-550 text-[15px] md:h-[50px]">
            <div
              className="relative flex h-full w-full rounded-lg"
              style={{
                background: `linear-gradient(to left,#fff 0%,#fff 50%,#0577AF 50%,#0577AF 100%)`,
              }}
            >
              <button
                name="search"
                className="flex items-center justify-center rounded-r-lg bg-white px-3 md:px-4"
                aria-label="search button"
              >
                <Search />
              </button>
              <input
                onFocus={() => setOpen(true)}
                onBlur={() => setOpen(false)}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  delayedQuery({ text: e.target.value })
                }
                onKeyUp={handleClickSearch}
                type="text"
                placeholder="جستجوی ساده"
                className="w-full flex-1 rounded-l-lg py-2 pl-1 text-xs text-blue-550 placeholder-blue-550 outline-none md:w-80 md:pl-4 md:text-base"
              />
              <Link href={"/search"}>
                <button className="flex h-full items-center px-3 text-center text-xs font-bold text-white md:px-4 md:text-base">
                  جستجوی پیشرفته
                </button>
              </Link>
              {open && !!variables?.query && (
                <ul className="scrollbar-none absolute top-14 z-40 max-h-72 w-full space-y-2 overflow-y-scroll rounded-b-lg rounded-t bg-white p-2 shadow">
                  <>
                    {" "}
                    <Vlist
                      data={pagesData}
                      isLoading={isFetching}
                      ListEmptyComponent={
                        <div className="flex">
                          <EmptyWarning className="mx-2" />
                          نتیجه ای برای این جستجو یافت نشد
                        </div>
                      }
                      LoadingComponent={
                        <div className="flex h-full w-full items-center justify-center">
                          <Spinner />
                        </div>
                      }
                      renderItem={(data: any, idx: any) => {
                        return (
                          <Link
                            href={{
                              href: `/${
                                data?.productType == 0
                                  ? "course"
                                  : "package-details"
                              }/${data?.id}`,
                              pathname: data?.seoUrlDescription
                                ? `/${
                                    data?.productType == 0
                                      ? "course"
                                      : "package-details"
                                  }/${data?.id}/${encodeURIComponent(
                                    data?.seoUrlDescription
                                  )}`
                                : `/${
                                    data?.productType == 0
                                      ? "course"
                                      : "package-details"
                                  }/${data?.id}`,
                            }}
                          >
                            <a>
                              <li
                                // onClick={(e: any) => {
                                //     router.push(
                                //         `/${
                                //             data?.productType == 0
                                //                 ? 'course'
                                //                 : 'package-details'
                                //         }/${data?.id}`,
                                //         {
                                //             pathname: data?.seoUrlDescription
                                //                 ? `/${
                                //                       data?.productType == 0
                                //                           ? 'course'
                                //                           : 'package-details'
                                //                   }/${
                                //                       data?.id
                                //                   }/${encodeURIComponent(
                                //                       data?.seoUrlDescription,
                                //                   )}`
                                //                 : `/${
                                //                       data?.productType == 0
                                //                           ? 'course'
                                //                           : 'package-details'
                                //                   }/${data?.id}`,
                                //         },
                                //     );
                                // }}
                                onMouseDown={(e) => e.preventDefault()}
                                className="cursor-pointer rounded-lg py-1 px-3 text-[16px] transition-all hover:bg-[#d2e7f1]"
                              >
                                {data.name}
                              </li>
                            </a>
                          </Link>
                        );
                      }}
                      onEndReached={() => {
                        const currentPage = data?.pages?.length || 1;
                        if (
                          currentPage < data?.pages &&
                          data?.pages[0]?.pagination?.totalPages
                        ) {
                          fetchNextPage({ pageParam: currentPage + 1 });
                        }
                      }}
                      className="mt-1 flex w-full flex-col rounded-md"
                    />
                  </>
                </ul>
              )}
            </div>
          </div>
        </Tooltip>
      </div>
    </>
  );
};

export default SearchBar;
